/* 1.引入文件 */

import Vue from "vue";

import axios from "axios"; //引入 axios库
import baseurl from "./baseurl.js";
import router from "../router";
import Message from "element-ui/lib/message";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false }); //去除加载中圆圈
// axios.defaults.withCredentials = true; //需要在请求中携带cookies或其他认证信息设置为true
const MESSAGE_DURATION = 3000;
const TOKEN_WAIT_TIMEOUT = 10000;
const TOKEN_POLL_INTERVAL = 500;
let tokenWaitPromise = null;

function showMessage(options) {
  return Message({
    ...options,
    duration: options && options.duration !== undefined ? options.duration : MESSAGE_DURATION,
  });
}

function getRequestToken(config) {
  const headers = (config && config.headers) || {};
  return (
    headers.Authorization ||
    headers.authorization ||
    (headers.common && (headers.common.Authorization || headers.common.authorization)) ||
    ""
  );
}

function waitForTokenRenewal(failedToken) {
  const currentToken = localStorage.getItem("jyx_token");
  if (currentToken && currentToken !== failedToken) {
    return Promise.resolve(currentToken);
  }

  if (!tokenWaitPromise) {
    tokenWaitPromise = new Promise((resolve, reject) => {
      let pollTimer = null;
      let timeoutTimer = null;

      const cleanup = () => {
        if (pollTimer) clearInterval(pollTimer);
        if (timeoutTimer) clearTimeout(timeoutTimer);
      };

      const checkToken = () => {
        const token = localStorage.getItem("jyx_token");
        if (token && token !== failedToken) {
          cleanup();
          resolve(token);
        }
      };

      pollTimer = setInterval(checkToken, TOKEN_POLL_INTERVAL);
      timeoutTimer = setTimeout(() => {
        cleanup();
        const timeoutError = new Error("登录状态更新超时，请重新登录");
        timeoutError.code = "AUTH_TOKEN_TIMEOUT";
        showMessage({
          message: timeoutError.message,
          type: "warning",
        });
        reject(timeoutError);
      }, TOKEN_WAIT_TIMEOUT);

      checkToken();
    }).finally(() => {
      tokenWaitPromise = null;
    });
  }

  return tokenWaitPromise;
}

const baseURL = baseurl.baseUrl;
const service = axios.create({
  baseURL,
  timeout: 3000000,
});
service.interceptors.request.use(
  async config => {
    NProgress.start();
    if (config.method == "get") {
      //判断get请求
      config.params = config.params || {};
      config.params.t = Date.parse(new Date()) / 1000; //添加时间戳  防止接口缓存
    }
    if (!config.type) {
      //有type  不传token
      const token = localStorage.getItem("jyx_token");
      if (token) {
        config.headers.common["Authorization"] = token;
      } else {
        // 没有token，等待1秒后重试
        await new Promise(resolve => setTimeout(resolve, 1000));
        const newToken = localStorage.getItem("jyx_token");
        if (newToken) {
          config.headers.common["Authorization"] = newToken;
        }
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);
let isHandling401 = false;
service.interceptors.response.use(
  async response => {
    if (response.status === 200) {
      NProgress.done();
      const data = response.data;

      if (data.code == 401) {
        if (!response.config.retry) {
          response.config.retry = true; // 标记已重试，不再重复刷

          try {
            if (window.__POWERED_BY_QIANKUN__ && localStorage.getItem("ip_user") != 1) {
              // 1. 如果是主应用下的正常用户，调用主应用 leftbar 提供的刷新方法
              if (window.refreshToken) {
                await window.refreshToken();
              }
            } else {
              // 独立运行时 或 IP用户（包括qiankun下的IP用户）的无感刷新
              response.config.ipLoginChecked = true;
              if (!window.__CHONGDA_LOGIN_CHECK_PROMISE__) {
                window.__CHONGDA_LOGIN_CHECK_PROMISE__ = new Promise(resolve => {
                  const tempAxios = axios.create({ baseURL: baseURL });
                  tempAxios
                    .get("/api/v1/plug/getIpUser")
                    .then(ipRes => {
                      if (ipRes.data && ipRes.data.code == 200 && ipRes.data.data) {
                        tempAxios
                          .post("/api/v1/login", {
                            username: ipRes.data.data.userName,
                            password: ipRes.data.data.password,
                          })
                          .then(loginRes => {
                            if (loginRes.data && loginRes.data.code == 200) {
                              localStorage.setItem("jyx_token", loginRes.data.token);
                            }
                            resolve();
                          })
                          .catch(() => resolve());
                      } else {
                        resolve();
                      }
                    })
                    .catch(() => resolve());
                }).finally(() => {
                  window.__CHONGDA_LOGIN_CHECK_PROMISE__ = null;
                });
              }
              await window.__CHONGDA_LOGIN_CHECK_PROMISE__;
            }

            // 3. 重新发一次刚刚失败的请求
            const newToken = localStorage.getItem("jyx_token");
            response.config.headers.Authorization = newToken;
            response.config.headers.token = newToken;
            if (response.config.headers.common) {
              response.config.headers.common["Authorization"] = newToken;
            }
            return service(response.config);
          } catch (err) {
            console.error("刷新 token 失败", err);
          }
        }

        // ============== 重试后依然 401，走原登出逻辑 ==============
        if (response.config.retry) {
          window.parent.postMessage(
            {
              type: "REDIRECT_STATUS", // 消息类型，用于父页面识别
              data: {
                status: "REDIRECTING_TO_LOGIN",
              }, // 最新的用户资料
            },
            "*", // 父页面的域名（Vue 项目的地址），* 表示所有域名（不推荐）
          );
          // ===== 添加状态锁判断 =====
          if (response.config.ipLoginChecked) return Promise.reject("token 失效");
          if (isHandling401) return Promise.reject("token 失效"); // 如果已在处理，直接返回
          isHandling401 = true; // 标记为正在处理
          // 先调用IP用户接口
          if (router.history.current.query.redirect) {
            redirectToLoginPage();
            return Promise.reject("token 失效");
          } else {
            // 没有 redirect 参数，调用 IP 用户接口
            checkIPUserAndRedirect();
            return Promise.reject("token 失效");
          }
        }
      } else if (data.code !== 200 && data.code != 1 && data.code != 100) {
        showMessage({
          message: data.msg,
          type: "error",
        });
      }
      return data;
    }
  },
  async error => {
    if (error.response && error.response.status === 401) {
      const requestConfig = error.config || {};
      if (requestConfig.http401Retried) {
        NProgress.done();
        return Promise.reject(error);
      }

      requestConfig.http401Retried = true;
      const failedToken = getRequestToken(requestConfig);

      try {
        const renewedToken = await waitForTokenRenewal(failedToken);
        requestConfig.headers = requestConfig.headers || {};
        requestConfig.headers.Authorization = renewedToken;
        requestConfig.headers.token = renewedToken;
        if (requestConfig.headers.common) {
          requestConfig.headers.common.Authorization = renewedToken;
        }
        return service.request(requestConfig);
      } catch (authError) {
        NProgress.done();
        return Promise.reject(authError);
      }
    }
    showMessage({
      message: error.msg || error.message,
      type: "error",
    });
    return Promise.reject(error);
  },
);
// 添加IP用户检测和重定向处理函数
function checkIPUserAndRedirect() {
  if (window.__CHONGDA_LOGIN_CHECK_PROMISE__) {
    return;
  }
  // 创建一个新的axios实例来避免拦截器循环调用
  localStorage.removeItem("systemName");
  const tempAxios = axios.create({
    baseURL: baseURL,
    timeout: 5000,
  });

  tempAxios
    .get("/api/v1/plug/getIpUser")
    .then(ipRes => {
      setTimeout(() => {
        if (ipRes.data && ipRes.data.code == 200 && ipRes.data.data && ipRes.data.data.userName) {
          // IP用户检测成功，获取用户信息
          const userName = ipRes.data.data.userName;
          const password = ipRes.data.data.password;
          const remark = ipRes.data.data.remark;
          // 检查用户状态（新增）
          tempAxios
            .get(`/api/v1/system/ipuser/user/state?userName=${userName}`)
            .then(stateRes => {
              if (stateRes.data.data != "符合条件" && stateRes.data.data.indexOf("IP") == -1) {
                showMessage({
                  message: stateRes.data,
                  type: "error",
                });
                return;
              } else {
                // 检查结果是否包含IP信息，如果包含则提取提示内容
                let warningMessage = "";
                if (stateRes.data.data.indexOf("IP") !== -1) {
                  // 去掉"IP"相关内容，只保留提示信息
                  warningMessage = stateRes.data.data.replace(/IP/gi, "").trim();
                  // 保存提示信息到localStorage
                  localStorage.setItem("ipWarning", warningMessage);
                } else {
                  // 如果没有IP信息，清空提示
                  localStorage.removeItem("ipWarning");
                }
                // 状态符合条件或包含IP信息，继续静默登录
                let postBody = {
                  username: userName,
                  password: password,
                };

                // 静默登录
                tempAxios
                  .post("/api/v1/login", postBody)
                  .then(loginRes => {
                    if (loginRes.data && loginRes.data.code == 200) {
                      // 静默登录成功，更新token
                      localStorage.setItem("jyx_token", loginRes.data.token);
                      localStorage.setItem("userName", userName);

                      // 获取用户信息以获取schoolName
                      tempAxios
                        .post(
                          "/api/v1/user/info",
                          {},
                          {
                            headers: { Authorization: loginRes.data.token },
                          },
                        )
                        .then(userRes => {
                          if (userRes.data && userRes.data.code == 200) {
                            const schoolName = userRes.data.data.schoolName;
                            // 调用getSystemInfo接口获取sysName
                            tempAxios
                              .get(`/api/v1/system/ipuser/customer/info?schoolName=${encodeURIComponent(schoolName)}`, {
                                headers: { Authorization: loginRes.data.token },
                              })
                              .then(sysRes => {
                                if (sysRes.data && sysRes.data.code == 200) {
                                  // 保存sysName到localStorage
                                  localStorage.setItem("systemName", sysRes.data.data.sysName);
                                }
                                // 所有数据获取完成后刷新页面
                                // window.location.reload();
                              })
                              .catch(() => {
                                // 异常情况下仍刷新页面
                                window.location.reload();
                              });
                          } else {
                            window.location.reload();
                          }
                        })
                        .catch(() => {
                          window.location.reload();
                        });
                    } else {
                      // 静默登录失败，跳转到登录页
                      redirectToLoginPage();
                    }
                  })
                  .catch(() => {
                    // 登录请求失败，跳转到登录页
                    redirectToLoginPage();
                  });
              }
            })
            .catch(() => {
              // 状态检查失败，跳转到登录页
              redirectToLoginPage();
            });
        } else {
          // 不是IP用户或IP用户检测失败，跳转到登录页
          isHandling401 = false; // 异常时重置状态锁
          redirectToLoginPage();
        }
      }, 1000);
    })
    .catch(() => {
      // IP用户接口调用失败，跳转到登录页
      redirectToLoginPage();
    });
}

// 处理重定向到登录页的函数
function redirectToLoginPage() {
  if (window.__POWERED_BY_QIANKUN__) {
    // 如果在 qiankun 环境中，获取不到 IP 用户则交给主应用去登录，或者什么都不做
    console.warn("子应用检测到401，且获取不到IP用户，交由主应用处理");
    return;
  }
  // 获取当前完整的浏览器URL
  const currentBrowserUrl = window.location.href;
  // 获取当前路径并进行编码
  let currentPath = encodeURIComponent(router.history.current.fullPath);

  // 检查当前路径是否包含school_login，如果是则不执行重定向
  if (router.history.current.fullPath.includes("school_login") || router.history.current.fullPath.includes("asp_login") || router.history.current.fullPath.includes("login")) {
    isHandling401 = false; // 重置状态锁
    return; // 不执行重定向
  }
  // 检查浏览器地址中是否包含jyx或cxaitest
  let domainFlag = "";
  if (currentBrowserUrl.includes("jyx")) {
    domainFlag = "jyx";
  } else if (currentBrowserUrl.includes("cxaitest")) {
    domainFlag = "cxaitest";
  }
  // 如果存在特殊标识，且当前路径中还没有urldomain参数，则拼接到currentPath中
  if (domainFlag && !currentPath.includes("urldomain=")) {
    // 检查currentPath是否已经包含查询参数
    if (currentPath.includes("?")) {
      currentPath += `&urldomain=${domainFlag}`;
    } else {
      currentPath += `?urldomain=${domainFlag}`;
    }
  }
  // 执行路由跳转
  // router.push({ path: "/lg", query: { redirectUrl: currentPath } });
  isHandling401 = false; // 跳转后重置状态锁
}
// 添加IP地址比较函数
async function compareIPAddresses() {
  try {
    // const ipifyResponse = await axios.get('http://ip-api.com/json/');
    // const clientIP = ipifyResponse.data.query;
    const response = await axios.get("https://httpbin.org/ip");
    this.userIP = response.data.origin;
    console.log("客户端公网IP:", userIP);
    // 优先级：x-real-ip > x-forwarded-for（第一个IP） > remote-addr
  } catch (error) {
    // console.error("IP地址比较失败:", error);
    // 异常情况下默认视为IP不一致
    return false;
  }
}
export default service;
